<template>
<g>
  <circle :class="{ selected: isSelected }" :cx="getX" :cy="getY" :r="getRadius" :style="{fill: color}"/>
  <KobiViewTemplateTag v-if="data.troisTag" :tag="data.troisTag" :element="data" :center="getCenter" />
</g>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import KobiViewTemplateTag from './KobiViewTemplateTag.vue';

export default {
  props: ['data'],
  events: ['click'],

  components: { KobiViewTemplateTag },

  computed: {
    ...mapState('general', ['group', 'grouping']),
    ...mapGetters('general', ['getSelectedElements']),
    
    getX() {
      return this.getPoints[0];
    },
    getY() {
      return this.getPoints[1];
    },
    getCenter() {
      return [ this.getX, this.getY ];
    },
    getRadius() {
      return this.data.TempPbi2DGeometry.Radius;
    },
    getPoints() {
      return this.data.TempPbi2DGeometry.Points[0];
    },

    isSelected() {
      return this.getSelectedElements.find(x => x.ID == this.data.ID);
    },

    color() {
      return this.data.troisColor || '#aaaaaa';
    },
  },

  methods: {
    getColor() {
      if(this.group)
        return this.grouping.find(x => x.group == this.data[this.group]).color;
      return 'aaaaaa'
    },

    setColor() {
      this.colorFill = '#' + this.getColor();
    },
  },
  
  watch: {
    group() {
      this.setColor();
    },
    grouping() {
      this.setColor();
    },
  },

  data() {
    return {
      container: null,
      colorFill: '#aaa',
    }
  },

  mounted() {
    this.setColor();
  },
}
</script>

<style>
.selected {
  stroke: yellow;
  stroke-width: 1;
}
</style>